import React, {useState} from 'react';

import {Button, NumberInput, Text} from '@albert-io/atomic';

import OnboardingPageLayout from '../OnboardingPageLayout';

interface AgeCheckStepProps {
  onSubmit: (age: number) => void;
}

// Albert serves K-12 and higher-ed.
const MAX_AGE = 120;

export default function AgeCheckStep({onSubmit}: AgeCheckStepProps) {
  const [age, setAge] = useState('');
  const [error, setError] = useState(false);

  const handleSubmit = () => {
    const ageNum = parseInt(age, 10);
    if (!isNaN(ageNum) && ageNum > 0 && ageNum <= MAX_AGE) {
      setError(false);
      onSubmit(ageNum);
    } else {
      setError(true);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setAge(e.target.value);
    if (error) setError(false);
  };

  return (
    <OnboardingPageLayout>
      <div className='flex flex-col gap-x0-half'>
        <Text className='text-xxl font-black' data-testid='age-check-step__heading'>
          Age Verification
        </Text>
        <Text>In order to use Albert, we need to know how old you are.</Text>
      </div>

      <div className='px-x1'>
        <NumberInput
          min={1}
          max={MAX_AGE}
          status={error ? 'negative' : undefined}
          placeholder='Enter your age'
          value={age}
          onChange={handleChange}
          aria-label='Age'
          data-testid='new-age-input'
        />
        {error && (
          <Text size='s' color='negative' className='mt-x0-half'>
            Please enter a valid age.
          </Text>
        )}
      </div>

      <Button
        className='w-full'
        color='primary'
        size='l'
        roundness='pill'
        disabled={!age}
        onClick={handleSubmit}
      >
        <Text color='primary-inverse-static'>Submit</Text>
      </Button>
    </OnboardingPageLayout>
  );
}
